module.exports = __webpack_public_path__ + "img/farewell_13.e2b35195.jpg";